import { DEFAULT_USER, INTEGRATION_DOCUMENT } from '~/consts/psf';
import apiPSFAnon from '~/services/apiPSFAnon';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { getRawDocument } from '~/utils/string';

interface Params {
  certificateCode: string;
  insuranceCompanyCode: string;
  insuranceCompanyName: string;
  document: string;
  type: 'AUTO' | 'MARISACUIDA' | 'BOLSAPROTEGIDA' | 'PERDARENDA';
}

export async function registerIntentionUseCase({
  certificateCode,
  insuranceCompanyCode,
  insuranceCompanyName,
  document,
  type,
}: Params): Promise<boolean> {
  try {
    const [origin] = MarisaAppUtils.getOriginTypeInfos();

    await apiPSFAnon.post('/pssservices/api/oInsurence/registrarIntencao', {
      numCotacao: certificateCode,
      codSeguradora: insuranceCompanyCode,
      nomeSeguradora: insuranceCompanyName,
      cpfUsuario: Number(INTEGRATION_DOCUMENT),
      loginUsuario: DEFAULT_USER,
      ipUsuario: '10.10.10.10',
      idProcesso: '202020202020',
      idServico: '49404049409090',
      service: 'oInsurence',
      functionality: 'registrarIntencao',
      filial: 1033,
      origem: origin,
      fluxo: 'OFERTA_SEGUROS',
      modulo: '2',
      codParceiro: 'OINSURANCE',
      tipSeguro: type,
      tipoPessoa: 'FISICA',
      cpfCnpj: getRawDocument(document),
    });
    return true;
  } catch {
    return false;
  }
}
